export const CLIENT_TYPE_HEADER = 'web'
